import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import DropdownDomainCard from 'components/DomainCard/DropdownDomainCard';
import DomainPage from 'scenes/DomainPage';
import classnames from 'classnames';
import copy from 'copy-to-clipboard';

import domainImg from 'images/iphone-domainImg.png';
import linkCopy from 'images/link-copy.svg';
import linkGo from 'images/link-go.svg';
import AlertMessage from 'components/AlertMessage';

import { DOMAIN_PAGE_PATH } from 'routes';
import IframePreviewComponent from 'components/IframePreviewComponent';

class DomainCard extends Component {
  state = {
    showAlert: false,
  };
  handleCopy = text => {
    copy(text);
    this.setState({ showAlert: true });
    setTimeout(() => this.setState({ showAlert: false }), 4000);
  };
  openNewTab = target => {
    window.open(target, '_blank');
  };
  render() {
    const {
      id,
      handleEdit,
      domainTitle,
      domainName,
      toggleModalEdit,
      toggleModalDelete,
      handleDelete,
      editable_shortcode,
      nonDeletable,
      premium_shortcode,
    } = this.props;
    const { showAlert } = this.state;
    return (
      <div className="domain-card">
        {showAlert && <AlertMessage text="Your link copied to clipboard!" />}
        <DropdownDomainCard
          editableShortcode={editable_shortcode}
          toggleModalEdit={toggleModalEdit}
          toggleModalDelete={toggleModalDelete}
          nonDeletable={nonDeletable}
        />
        <div className="domain-card__content">
          <Link
            to={DOMAIN_PAGE_PATH + '/' + id + '/content'}
            className="domain-card__link"
            style={{ position: 'relative' }}>
            <div
              className="blocker"
              style={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                zIndex: '1',
              }}
            />
            <div className="domain-card__phone">
              <div className="domain-card__phone-inner">
                <div className="domain-card__frame">
                  <IframePreviewComponent
                    src={domainName}
                    domainClass="domain-iframe"
                    style={{ zIndex: 2 }}
                  />
                </div>
              </div>
            </div>
            <div className="domain-card__descr">
              <div className="domain-card__inner">
                <div className="domain-card__title">{domainTitle}</div>
                <div
                  className={classnames('domain-card__name', {
                    orange: premium_shortcode,
                  })}>
                  {domainName}
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="domain-card__btn">
          <span
            title="Copy to clipboard"
            onClick={() => this.handleCopy(domainName)}
            className="link-btn__itm">
            <img src={linkCopy} alt="" />
          </span>
          <span
            title="Open in new tab"
            onClick={() => this.openNewTab(domainName)}
            className="link-btn__itm">
            <img src={linkGo} alt="" />
          </span>
        </div>
      </div>
    );
  }
}

export default DomainCard;



// WEBPACK FOOTER //
// ./src/components/DomainCard/DomainCard.js